import { render } from "./App.vue?vue&type=template&id=480bcdb4"
const script = {}

import exportComponent from "../node_modules/.pnpm/@vue+cli-service@5.0.9_@vue_69b1736899fbf5543e1317e199a8546b/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__